export default class ConstructionStepNew {
  constructor(
    public id?: number,
    public name?: string,
    public title: string = "",
    public status: string = "",
    public comment: string = "",
    public progress: number = 0,
    public startDate?: string | number,
    public endDate?: string | number | null,
    public action?: string | null
  ) {}
}
